import type { SxProps, Theme } from "@mui/material";
import { MIN_TAP_TARGET, MOBILE_BREAKPOINT } from "@/styles/responsive";

// 地図画面（左の列・ツールバー・メニュー・物件一覧の表）の部品の大きさ。
// PC は地図を広く見せるため、MUI の標準より一回り小さくそろえる。
// SP は指で押すので、タップ領域の最低限（MIN_TAP_TARGET）を確保する。

/** ボタンの高さ（sx に渡す）。左の列の検索欄（SearchBox）も同じ高さにする */
export const MAP_BUTTON_HEIGHT = {
  xs: MIN_TAP_TARGET,
  [MOBILE_BREAKPOINT]: 32,
} as const;

/** ボタン・メニュー・表の文字。左の列は狭いので小さめの 12px にそろえる */
export const MAP_CONTROL_TEXT_SX = {
  fontSize: "0.75rem",
  lineHeight: 1.5,
} as const;

/** メニュー（Action・検索結果・住宅地図）の中身。文字とアイコンをボタンに合わせて小さくする */
export const MAP_MENU_SX: SxProps<Theme> = {
  "& .MuiMenuItem-root": {
    ...MAP_CONTROL_TEXT_SX,
    minHeight: { xs: MIN_TAP_TARGET, [MOBILE_BREAKPOINT]: 32 },
  },
  "& .MuiMenuItem-root .MuiSvgIcon-root": {
    fontSize: 18,
  },
};

/** 地図の枠の線。地図の上の帯（地図の操作）も同じ線でつなげる */
export const MAP_BORDER = "1px solid #d0d7de";

/**
 * 地図の上の帯に置くボタン（住宅地図・ダウンロードなど、地図に対する操作）。
 * 左の列のボタン（白地に青枠）と見分けられるよう、枠なしの文字ボタンにする
 */
export const MAP_TOOLBAR_BUTTON_SX: SxProps<Theme> = {
  ...MAP_CONTROL_TEXT_SX,
  textTransform: "none",
  color: "text.primary",
  height: MAP_BUTTON_HEIGHT,
  px: 1,
  whiteSpace: "nowrap",
  "& .MuiButton-startIcon": { color: "primary.main" },
  "&:hover": { bgcolor: "action.hover" },
};

/** 物件一覧の表の行と見出しの高さ */
export const MAP_GRID_ROW_HEIGHT_PX = 40;
